/**
 * Centrale PDF-load voor pdfjs-dist in de browser.
 * - Worker-URL moet bij de geïnstalleerde pdfjs-dist-versie horen (meetingConstants.PDF_WORKER_SRC).
 * - Fallback: als directe URL-load faalt → fetch + ArrayBuffer (Storage/CORS/range).
 */

import { PDF_WORKER_SRC } from './meetingConstants';

export async function loadPdfDocumentFromUrl(
  url: string,
  onProgress?: (pct: number) => void,
) {
  const pdfjsLib = await import('pdfjs-dist');
  pdfjsLib.GlobalWorkerOptions.workerSrc = PDF_WORKER_SRC;

  const open = (params: { url: string } | { data: ArrayBuffer }) => {
    const task = pdfjsLib.getDocument(params);
    if (onProgress) {
      task.onProgress = (p: { loaded: number; total: number }) => {
        const pct = p.total > 0 ? Math.round((p.loaded / p.total) * 100) : 0;
        onProgress(pct);
      };
    }
    return task.promise;
  };

  try {
    return await open({ url });
  } catch {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) throw new Error(`PDF ophalen mislukt (${res.status})`);
    const data = await res.arrayBuffer();
    return open({ data });
  }
}
